var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-spinner infinite-spin rounded-full border-2 border-blue-300",style:({
    width: (_vm.size + "px"),
    height: (_vm.size + "px")
  })},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }